module.exports = __webpack_public_path__ + "img/lks.34cf3968.png";